import axios from "axios";
import constants from "../constants/constants";

const { GET_ME, GET_ME_SUCCESS, GET_ME_ERROR } = constants;

const GET_ME_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/me";

export const getUserAction = (config) => async (dispatch) => {
  dispatch({ type: GET_ME });
  await axios
    .get(GET_ME_API_END_POINT, config)
    .then((res) => {
      const { user } = res.data;
      dispatch({ type: GET_ME_SUCCESS, user });
    })
    .catch((error) => dispatch({ type: GET_ME_ERROR, error }));
};
